import { render, staticRenderFns } from "./LoveDrift.vue?vue&type=template&id=a1fa559c&"
import script from "./LoveDrift.vue?vue&type=script&lang=js&"
export * from "./LoveDrift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports